import PanelFilters from './PanelFilters'

export default PanelFilters
